'use strict';

import { setInSessionStorage, getFromSessionStorage } from '../util/session-storage-wrapper';
import ErrorType from '../constants/error-type';

var Sizzle = require('sizzle');
var VideoConfig = require('../config');
var Device = require('../util/device');
var Debug = require('../util/debug')('android-fallback');
var VideoAttributes = require('../util/video-attributes');
var VideoDataBuilder = require('../util/video-data-builder');

var _sessionStorageKey = 'currentChromecastStatus';

/**
 * Chromecast status enum
 */
var CHROMECAST_STATUS = {
	Disconnected: 'Disconnected',
	Connecting: 'Connecting',
	Connected: 'Connected'
};

var NAMESPACE = 'ios-native';
var videoData;

//chromecast bridge
window.IOSDeviceBridge = window.IOSDeviceBridge || {
	CHROMECAST_STATUS: CHROMECAST_STATUS,

	setChromecastStatus: function (status) {
        setInSessionStorage(_sessionStorageKey, status);
	},

	getChromecastStatus: function () {
		return getFromSessionStorage(_sessionStorageKey, CHROMECAST_STATUS.Disconnected);
	},

	isChromecastConnected: function () {
        return getFromSessionStorage(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
	}
};

//chromecast player plugin
module.exports = {
	create: function (api) {
		if (!Device.isIOSApp()) {
			return;
		}

		var storedPosition = 0,
			isPlaying = false;

		window.IOSDeviceBridge.getVideoPosition = function () {
			var pos = storedPosition;
			Debug('getting video position: %s', pos);

			return pos;
		};

		var oldSetStatus = window.IOSDeviceBridge.setChromecastStatus;
		window.IOSDeviceBridge.setChromecastStatus = function (status) {
			const currStatus = getFromSessionStorage(_sessionStorageKey);
			Debug('setting cc status to %s (old status = %s)', status, currStatus);
			oldSetStatus(status);
			if (status !== currStatus) {
				if (status === CHROMECAST_STATUS.Connected && isPlaying) {
					api.pause();
					_play(videoData);
				} else if (status === CHROMECAST_STATUS.Disconnected) {
					api.load();
				}
			}
		};

		function _getMetadataForIOSNativePlayer(videoId, onSuccess) {
			VideoConfig.metadataFetchFunction(videoId, (metadata) => {
					api.fire('metadata', metadata);
					if (api.data().inSweden !== undefined && !api.data().inSweden && (metadata.rights && metadata.rights.geoBlockedSweden)) {
						api.fire('error', {
							name: ErrorType.GEO_BLOCK_ERROR
						});

						return;
					}

					var videoData = VideoDataBuilder.build(videoId, metadata, api);

					videoData.video.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]);
					videoData.videoId = Number(videoData.videoId);
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});
					api.state().loading = false;
					api.state().ready = true;
					onSuccess(videoData);
				},
				(error, data) => {
					if (data) {
						api.fire('metadata', data);
					}
					api.fire('error', error);
				});
		}

		function _isConnected() {
			return getFromSessionStorage(_sessionStorageKey) === CHROMECAST_STATUS.Connected;
		}

		function _play(videoData) {
			var jsonURL = 'svtplay://api.svt.se/videoplayer-embed/android/videodata/?json=' + encodeURIComponent(JSON.stringify(videoData));
			storedPosition = api.getCurrentTime();
			window.location = jsonURL;
		}

		function _sendEvent(eventType, data) {
			if (api.fire) {
				api.fire(eventType, data);
			}
		}

		api.on(NAMESPACE + '.playing', function () {
			isPlaying = true;
		});

		api.on(NAMESPACE + '.pause', function () {
			isPlaying = false;
		});

		api.on(NAMESPACE + '.error', function () {
			isPlaying = false;
		});

		api.filters.push({
			load: function (videoId) {
				videoId = videoId || Sizzle('video', api.element())[0].getAttribute('data-video-id');
				if (_isConnected()) {
					api.element().on('click', function () {
						api.play();
					});

					_getMetadataForIOSNativePlayer(videoId, function (metadata) {
						videoData = metadata;
						api.state().ready = true;

						_sendEvent('ready', {
							videoId: videoId,
							externalUi: true
						});
					});

					return true;
				} else {
					api.once(NAMESPACE + '.metadata', function (metadata) {
						videoData = VideoDataBuilder.build(videoId, metadata.detail, api);
						videoData.video.position = VideoAttributes.getStartPosition(Sizzle('video', api.element())[0]);
						videoData.videoId = Number(videoData.videoId);
					});
				}

				return false;
			},
			play: function () {
				if (_isConnected()) {
					videoData.video.position = videoData.video.position || api.getCurrentTime();
					_play(videoData);
					api.reset();
					_sendEvent('ready', {
						videoId: videoData.videoId,
						externalUi: true
					});

					return true;
				}
			},
			pause: function () {
				return _isConnected();
			},
			seek: function () {
				return _isConnected();
			},
			getVolume: function () {
				return _isConnected();
			},
			isMuted: function () {
				if (_isConnected()) {
					return false;
				}

				return null;
			},
			mute: function () {
				return _isConnected();
			},
			showCaptions: function () {
				return _isConnected();
			},
			setVolume: function () {
				return _isConnected();
			}
		});

	},

	destroy: function (api) {
		api.off(NAMESPACE + '.playing');
		api.off(NAMESPACE + '.pause');
		api.off(NAMESPACE + '.error');
	}
};



// WEBPACK FOOTER //
// ./src/js/plugins/ios-native.js